export default class User {
  constructor({ username, email, firstName, isStaff } = {}) {
    this.username = username || "";
    this.email = email || "";
    this.firstName = firstName || "";
    this.isStaff = isStaff || false;
  }
}
